import { LOGIN_PATH } from './auth'
import store from 'src/store'
import { unregisterSSOLogin } from './index'
import Cookies from 'js-cookie'

import {
  SAMLLoginUrl, SolarSSOLogin, signUpUserHasEmailSaved, clearSavedEmailForAutoSignUp, startRefreshTokenWorker
} from 'src/components/Cognito'
import { possuiParametrosAutenticacaoKeycloak } from 'src/typescript/servicos/keycloak/utils'
import { keycloakSSOLogin } from 'src/typescript/servicos/keycloak/keycloak.servico'
import { consumirRedirectAposLoginSalvo, obterRotaDeLoginAposLogout } from './redirect-login'

/**
 * Função assíncrona que lida com a pós-autenticação do usuário.
 *
 * Esta função é responsável por realizar ações após a autenticação do usuário,
 * como obter informações do usuário, definir cookies e recarregar a interface
 * do frontend. Em caso de erro, a função captura o erro e realiza o logout do usuário.
 *
 * @async
 * @function lidarComPosAutenticacao
 * @returns {Promise<string | null>} Retorna a rota para redirecionamento pós-login, se existir.
 * @throws {Error} Lança um erro se ocorrer algum problema durante a execução.
 */
const lidarComPosAutenticacao = async () => {
  try {
    Cookies.set('acesso-login', true)
    /**
     * Remove os parâmetros de autenticação do keycloak da URL
     * para evitar que o front tente autenticá-lo novamente ao mudar de rota
     **/
    window.history.pushState({}, document.title, window.location.pathname + window.location.hash);

    await store.dispatch('getUserInfo', true)
    return consumirRedirectAposLoginSalvo()
  } catch (erro) {
    this.$filtradorDeErros.capturarErro(erro)
    await store.dispatch('logout', true)
    return null
  }
}

export async function realizeSSOLogin (...rota) {
  const [from, to, next] = rota
  // login Cognito SAML

  // unregister this before each to ensure that is called only once
  unregisterSSOLogin()

  const rotasDeLoginComSSO = {
    // Todos os clientes que utilizam SSO, são redirecionados para nosso sistema com o user_pool_id
    BV: window.location.href.includes('?user_pool_id='),
    SOLAR: window.location.href.includes('/login?token='),
    KEYCLOAK: possuiParametrosAutenticacaoKeycloak()
  }

  const utilizaLoginComSSO = [...Object.values(rotasDeLoginComSSO)].some(Boolean) && (from.name == null || to.path !== LOGIN_PATH)

  if (utilizaLoginComSSO) {
    // DO NOT DISPATCH 'logout' INSIDE THIS IF
    if (rotasDeLoginComSSO.SOLAR) {
      await SolarSSOLogin(...rota)
      const redirectAposLogin = await lidarComPosAutenticacao()
      if (redirectAposLogin) {
        next(redirectAposLogin)
        return null
      }
    } else if (rotasDeLoginComSSO.BV) {
      await SAMLLoginUrl()
      const redirectAposLogin = await lidarComPosAutenticacao()
      if (redirectAposLogin) {
        next(redirectAposLogin)
        return null
      }
    } else if (rotasDeLoginComSSO.KEYCLOAK) {
      await keycloakSSOLogin()
      const redirectAposLogin = store.getters.usuarioEstaAutenticado ? consumirRedirectAposLoginSalvo() : null
      if (redirectAposLogin) {
        next(redirectAposLogin)
        return null
      }
    }
  } else if (to.path === LOGIN_PATH) {
    try {
      await signUpUserHasEmailSaved()
    } catch {}
  } else if (to.name === 'cognito' && to.params.type === 'logout') {
    await store.dispatch('logout', false)
    clearSavedEmailForAutoSignUp()
    next(obterRotaDeLoginAposLogout())
    return null
  }
  next()
}

export async function startRefreshTokensWorkerForSSO () {
  if (store.state.auth.tokenAPI) {
    startRefreshTokenWorker()
  }
}
